


























































import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  props: ["field", "model", "to", "loading"],
  computed: {
    elementClass(): string {
      if (this.to?.elementClass) {
        if (this.to.elementClass.indexOf("col-") > -1) {
          return this.to.elementClass + " py-1";
        }
        return this.to.elementClass;
      }
      return "";
    },

    // ✅ Reactive + EXACT 768px breakpoint
    isMobile(): boolean {
      return this.$vuetify
        ? this.$vuetify.breakpoint.width <= 768
        : window.innerWidth <= 768;
    },

    // ✅ THIS WAS MISSING (CAUSE OF ERROR)
    hasData(): boolean {
      const rows = this.model?.[this.field?.key];
      return Array.isArray(rows) && rows.length > 0;
    }
  }
})
export default class VAlynkSimpleTable extends Vue {
  public to!: any;
  public loading!: boolean;
}
